import { DateTime } from "luxon";

let timeout = null;
export const delayKeyUp = (action: any, ms?: number) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
        if (action) {
            action();
        }
    }, ms ? ms : 300);
}
export const simulateDelay = (delayInms) => {
    return new Promise(resolve => setTimeout(resolve, delayInms));
};

export const DateFormatter = {
    epochToDateAndTime: (epoch: number) => {
        const d = new Date(epoch * 1000);
        const date = d.toISOString().substring(0, 10);
        const time = d.toTimeString();
        return date + " " + time.substring(0, 8);
    },
    epochToDateAndTimeObj: (epoch: number) => {
        const d = new Date(epoch * 1000);
        const date = d.toISOString().substring(0, 10);
        const time = d.toTimeString();
        return {
            date: date,
            time: time,
            str: date + " " + time.substring(0, 8)
        };
    },
    dateKeyToDate: (e: number) => {

        if (!e || e?.toString()?.length != 8) {
            return "-";
        }


        const y = e?.toString().substring(0, 4);
        const m = e?.toString().substring(4, 6);
        const d = e?.toString().substring(6, 8);

        return y + "-" + m + "-" + d;
    },
    dateKeyToDayInWeek: (e: number) => {
        if (!e || e?.toString()?.length != 8) {
            return "-";
        }
        const y = e?.toString().substring(0, 4);
        const m = e?.toString().substring(4, 6);
        const d = e?.toString().substring(6, 8);
        var dte = DateTime.fromISO(y + "-" + m + "-" + d);

        return ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"][dte.weekday - 1];
    },
    dateKeyToWeekdayNumber: (e: number) => {
        if (!e || e?.toString()?.length != 8) {
            return "-";
        }
        const y = e?.toString().substring(0, 4);
        const m = e?.toString().substring(4, 6);
        const d = e?.toString().substring(6, 8);
        var dte = DateTime.fromISO(y + "-" + m + "-" + d);

        return dte.weekday;
    }
}

export const StringHelper = {
    isGuid: (str: string): boolean => {
        if (!str) { return false; }

        var regex = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
        const res = str.match(regex);
        // setIsValid(!!res && replacement.newplantpartition?.length > 3);
        return !!res;
    },
    coalesce: (s1?: string, s2?: string, s3?: string, s4?: string, s5?: string) => {
        if (!!s1) { return s1; }
        if (!!s2) { return s2; }
        if (!!s3) { return s3; }
        if (!!s4) { return s4; }
        if (!!s5) { return s5; }
        return "";
    }
}


export const SortHelper = {
    sortAscending: (a: any, b: any, propName?: string): number => {

        const ak = Object.hasOwn(a, propName) ? a[propName] : a;
        const bk = Object.hasOwn(a, propName) ? b[propName] : b;

        if (ak > bk) { return 1; }
        else if (ak < bk) { return -1; }
        else { return 0; }
    },

    sortDescending: (a: any, b: any, propName?: string): number => {
        const ak = Object.hasOwn(a, propName) ? a[propName] : a;
        const bk = Object.hasOwn(a, propName) ? b[propName] : b;

        if (ak > bk) { return -1; }
        else if (ak < bk) { return 1; }
        else { return 0; }
    }
}